import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { bio } from '@/data/projects'

const navLinkClass =
  'relative text-body-sm text-text-secondary hover:text-text-primary transition-colors after:absolute after:bottom-0 after:left-0 after:h-px after:w-full after:bg-accent after:origin-right after:scale-x-0 hover:after:origin-left hover:after:scale-x-100 after:transition-transform after:duration-300'

function NavTextLink({ to, href, children }: { to?: string; href?: string; children: ReactNode }) {
  if (to) {
    return (
      <Link to={to} className={navLinkClass}>
        {children}
      </Link>
    )
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={navLinkClass}>
      {children}
    </a>
  )
}

export default function Nav() {
  return (
    <nav className="sticky top-0 z-50 bg-background/80 backdrop-blur-md border-b border-border/50">
      <div className="max-w-container mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img
            src="/favicon.png"
            alt="Natalia Tarasova"
            width={28}
            height={28}
            decoding="async"
            className="h-7 w-auto"
          />
          <span className="hidden xs:inline text-h4 font-semibold text-text-primary">
            Natalia Tarasova
          </span>
        </Link>
        <div className="flex items-center gap-8">
          <NavTextLink to="/#work">Work</NavTextLink>
          <NavTextLink to="/#about">About</NavTextLink>
          <NavTextLink href={bio.resumeUrl}>CV</NavTextLink>
        </div>
      </div>
    </nav>
  )
}
